<template>
    <div class="grid-container">
        <div class="notifier-image"><img :src="profilePic" alt=""></div>
        <div class="notifier-text">
            <a href="#" class="profile-link">{{ userName }}</a>
            <p class="notifier-t">{{ action }}</p>
            <a href="#" class="notifier-action" v-show="!actionName == ''">{{ actionName }}</a>
            <span v-show="!isReaded" class="notifier-badge"></span>
            <img class="notifier-pic" v-show="!notificationPic == ''" :src="notificationPic" alt="">
            <p class="notifier-time">{{ time }}</p>
        </div>
        <div></div>
        <div v-show="!message == ''" class="notifier-msg">
            <div >
                <p>{{ message }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotificationItem',
    props: {
        profilePic: String,
        userName: String,
        action: String,
        actionName: String,
        notificationPic: String,
        time: String,
        message: String,
        isReaded: Boolean
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@500;800&display=swap');

.grid-container {
    display: grid;
    grid-template-columns: 60px auto;
    padding-left: 40px;
    padding-right: 40px;
    margin-bottom: 35px;
}

.notifier-image img {
    width: 40px;
}

.notifier-text {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 16px;
}

.profile-link {
    text-decoration: none;
    color: hsl(224, 21%, 14%);
    font-weight: 800;
    margin-right: 5px;
}

.profile-link:hover {
    color: hsl(219, 85%, 26%);
}

.notifier-t {
    display: inline;
    margin-right: 5px;
    color: hsl(219, 12%, 42%);
}

.notifier-action {
    text-decoration: none;
    color: hsl(219, 12%, 42%);
    font-weight: 800;
    margin-right: 5px;
}

.notifier-action:hover {
    color: hsl(219, 85%, 26%);
}

.notifier-badge {
    background: hsl(1, 90%, 64%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
}

.notifier-time {
    color: hsl(219, 14%, 63%);
    font-size: 0.9rem;
    padding-top: 8px;
}

.notifier-msg {
    padding-top: 10px;
    font-family: 'Plus Jakarta Sans', sans-serif;
}

.notifier-msg div {
    border: 1px solid hsl(205, 33%, 90%);
    padding: 20px;
    padding-right: 0;
    border-radius: 5px;
    width: 560px;
    cursor: pointer;
}

.notifier-msg div:hover {
    background: hsl(211, 68%, 94%)
}

.notifier-msg div p {
    color: hsl(219, 12%, 42%);
    line-height: 1.3;
    padding-right: 20px;
}

.notifier-pic {
    float: right;
    width: 40px;
    cursor: pointer;
}

@media only screen and (max-width: 440px){
    .grid-container{
        padding-left: 20px;
        padding-right: 20px;
    }

    .notifier-msg div{
        width: 220px;
    }

}
</style>